module.exports = __webpack_public_path__ + "img/Feature.07685155.png";